import { Menu as AntMenu, type MenuItemProps as AntMenuItemProps, type MenuProps as AntMenuProps } from "antd/es";
import React from "react";

export interface MenuClickParams {
	key: string;
	keyPath: Array<string>;
	item: any;
	domEvent: any;
}

export type MenuProps = Pick<
	AntMenuProps,
	"mode" | "selectable" | "disabled" | "selectedKeys" | "defaultSelectedKeys" | "onClick" | "className"
>;

export const Menu: React.FC<React.PropsWithChildren<MenuProps>> = (props) => <AntMenu {...props} />;

export type MenuItemProps = Pick<AntMenuItemProps, "className" | "title" | "disabled" | "onClick">;

export const MenuItem: React.FC<React.PropsWithChildren<MenuItemProps>> = (props) => <AntMenu.Item {...props} />;

export const MenuDivider: React.FC = () => <AntMenu.Divider className="my-2.5" />;
